import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter, IonContent, IonSlides, IonSlide, IonLabel, IonInput, IonImg } from '@ionic/react';
import ReactDOM from 'react-dom';


import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';

import '../../../../css/qavaApp.css';


export function Modal_AddIngredientToRecipe (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [accessRights, setAccessRights ] = useState(authenticatedMerchent_context.accessRights);

    let [ingredientQtyCost, setIngredientQtyCost] = useState("1");
    let [measurementUnit, setMeasurementUnit] = useState("qty");

    
    let [viewInventoryAvailableProducts, setViewInventoryAvailableProducts] = useState([]);
    

    let [viewIonPopover, setvViewIonPopover] = useState(false);

    let [itemID_list, setItemID_list] = useState([]);   

    let [ingredientID, setIngredientID] = useState(null);
    let [ingredientName, setIngredientName] = useState(null);
    let [ingredientQtyInStock, setIngredientQtyInStock] = useState(null);

    
    useEffect(() => {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74401_retrieveingredient_list',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                ingredientID: cols[0],
                                ingredientName: cols[1],
                                ingredientDescription: cols[2],
                                ingredientPartNum: cols[3],
                                ingredientPhoneNumber: cols[4],
                                ingredientAddress: cols[5],
                                ingredientCity: cols[6],
                                ingredientCountry: cols[7],
                                ingredientCostPerUnit: cols[8],
                                ingredientSalePrice: cols[9],
                                ingredientQtyInStock: cols[10],
                                ingredientMeasurementType: parseFloat(cols[11]).toFixed(2),
                                ingredientDateCreated: parseFloat(cols[12]).toFixed(2),
                                ingredientAddedBy: cols[13],


                            });
                        });
                    }
                });
    }, []);
    

    function addItemID_list(event)
    {
        //alert("In Update Address");
        //alert(event)


        const newItem = {
            id: event[1], // Generate a new ID
            name: event[2], // Generate a new ID
            qtyCost: event[3],
            measurmentUnit: event[4], // Random price
          };


        //setItemID_list([...itemID_list, newItem]);

        setvViewIonPopover(false);
        props.confirmAdd(newItem);
        props.closeModal();
    }

    function popOverHandler(event)
    {
        //alert("in popoover handler");
        //alert(event);

        setIngredientID(event[1]);
        setIngredientName(event[2]);
        setIngredientQtyInStock(event[3]);

        setvViewIonPopover(true);
    }


    function closeModalHandler(event) {
        setViewInventoryAvailableProducts([]);
        props.closeModal(event);
    }


    return (
            <React.Fragment>
            {props.openModal == true ?
            (
            <IonModal id='showProductDetails' isOpen={ props.openModal}>
            <IonHeader style={{color: 'black'}}>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonText>ADD INGREDIENT</IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
             <IonContent className='grid_content'>
                        <IonGrid className='appGridContent'>
                                <IonRow>
                                    <IonCol size="12">
                                        <h3> Ingredient List </h3>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='2'>
                                        <h3> Item ID </h3>
                                    </IonCol>
                                    <IonCol size='2'>
                                        <h3> Name </h3>
                                    </IonCol>
                                    <IonCol size='5'>
                                        <h3> QtyInStock </h3>
                                    </IonCol>
                                    <IonCol size='3'>
                                        <h3> Action </h3>
                                    </IonCol>
                                </IonRow>
                                {viewInventoryAvailableProducts.map((detailData) => {
                                    return (
                                        <IonRow key={detailData.ingredientID}>
                                            <IonCol size='2'>{detailData.ingredientID}</IonCol>
                                            <IonCol size='2'>{detailData.ingredientName}</IonCol>
                                            <IonCol size='5'>{detailData.ingredientQtyInStock}</IonCol>
                                            <IonCol size='3'>
                                                <IonButton onClick={() => popOverHandler([true, detailData.ingredientID, detailData.ingredientName, detailData.ingredientQtyInStock])}>Add</IonButton>
                                            </IonCol>
                                        </IonRow>
                                    );
                                })}
                            </IonGrid>

                        
                {viewIonPopover == true && (

                        <div
                        style={{
                        position: 'absolute',
                        width: '75%',
                        height: '50%',
                        backgroundColor: 'white',
                        transform: 'translate(10%, 0%)',
                        padding: '16px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        zIndex: 1000,
                        borderRadius: '8px',       /* Rounded corners */
                        border: '2px rgb(0, 0, 0) solid',
                        }}
                        >

                        <IonGrid>
                                <IonRow >
                                    <IonCol size='6'>Name</IonCol>
                                    <IonCol size='6'>In-Stock</IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol size='6'>
                                        <IonText>{ingredientID}</IonText>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <IonText>{ingredientQtyInStock}</IonText>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='6'>
                                        <IonText>Quantity Cost</IonText>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <input type='number' onChange={(e) => setIngredientQtyCost(e.target.value)}></input>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='6'>
                                        <IonText>Measurement Unit</IonText>
                                    </IonCol>
                                    <IonCol size='6'>
                                    <select name="paymenttype" id='paymenttype' onChange={(e) => setMeasurementUnit(e.target.value) }>
                                        {/*<option value='cc'>Credit Card</option>*/}
                                        <option value='qty' selected='selected'>Unit</option>
                                        <option value='lb'>Pounds</option>
                                        <option value='ml'>Mililitters</option>*
                                    </select>
                                    </IonCol>
                                </IonRow>

                        </IonGrid>
                        <IonButton className='small_button' onClick={() => addItemID_list([true, ingredientID, ingredientName, ingredientQtyCost, measurementUnit])}>Confirm</IonButton>
                        <IonButton className='small_button' onClick={() => setvViewIonPopover(false)}>close</IonButton>
                        </div>
                        )}   

            </IonContent>

            <IonFooter class='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
    </IonModal>) : null}
    </React.Fragment>

    )
}